<template>
    <div class="bg-white text-gray-900 border-gray-400 border rounded shadow-lg">
        <div class="empty px-6 py-4" v-if="!(count)">
            <i class="fas fa-2x fa-handshake-alt-slash mr-5 mb-6"></i>
            <h2 class="font-exo font-bold text-xl mb-2">Quantidade de demissões</h2>
            <p class="warning text-base">Sem informações para exibir</p>
        </div>
        <div v-else>
            <div class="px-6 py-4">
                <i class="text-red-600 fas fa-2x fa-handshake-alt-slash mr-5 mb-6"></i>
                <h2 class="font-exo font-bold">
                    <span class="text-red-600 text-3xl" v-text="count">0</span>&nbsp;
                    <span class="font-exo uppercase">demissões</span>
                </h2>
                <div class="">
                    <small class="text-xs uppercase">Desde 01 de Março de 2020</small>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        props: {
            color: {
                type: String,
                default: '#ff281f'
            },
            count: {
                type: Number,
                required: true
            }
        },
    }
</script>